// Task 5: shared vocabulary for driver service screens.
// Readiness is always a state with reasons, never a number or percentage.

export const READINESS_LABEL = {
  READY: "Ready",
  REVIEW_REQUIRED: "Review required",
  UNAVAILABLE: "Unavailable",
  BLOCKED: "Blocked",
  NOT_APPLICABLE: "Not applicable",
};

export const READINESS_TONE = {
  READY: "bg-emerald-50 text-emerald-800 border-emerald-200",
  REVIEW_REQUIRED: "bg-amber-50 text-amber-900 border-amber-200",
  UNAVAILABLE: "bg-slate-100 text-slate-700 border-slate-200",
  BLOCKED: "bg-rose-50 text-rose-800 border-rose-200",
  NOT_APPLICABLE: "bg-slate-50 text-slate-500 border-slate-200",
};

export const AUTHORITY_LABEL = {
  VERIFIED_PROFESSIONAL: "Professional licence verified",
  NEEDS_VERIFICATION: "Licence needs verification",
  WRONG_LICENSE_CLASS: "Not a professional licence",
  WRONG_DL_CODE: "DL codes do not match",
  EXPIRING_SOON: "Licence expiring soon",
  EXPIRED: "Licence expired",
  SUSPENDED_OR_REVOKED: "Licence suspended or revoked",
  LEGALLY_BLOCKED: "Legally blocked",
};

export const ASSIGNMENT_STATUS_LABEL = {
  not_required: "Self-drive",
  pending: "Driver not assigned",
  assigned: "Driver assigned",
  pending_acceptance: "Waiting for driver acceptance",
  accepted: "Driver accepted",
  replacement_required: "DRIVER REPLACEMENT REQUIRED",
};

export const REQUIREMENT_LABEL = {
  LEGAL_REQUIREMENT: "Legal requirement",
  TRANSPORT_SPECIFIC: "Transport-specific",
  EMPLOYMENT_REQUIREMENT: "Employment requirement",
  EMPLOYER_POLICY: "Employer policy",
  OPTIONAL: "Optional",
  NEEDS_REVIEW: "Needs review",
};

export const EMPLOYMENT_STATUSES = ["PENDING_ONBOARDING", "ACTIVE", "INACTIVE", "SUSPENDED", "SEPARATED",
  "CONTRACTOR_REVIEW", "ARCHIVED"];
export const DUTY_STATUSES = ["OFF_DUTY", "AVAILABLE", "ON_BREAK", "REST_REQUIRED", "SICK_UNAVAILABLE",
  "TIME_OFF", "TEMPORARILY_UNAVAILABLE"];
export const HOLD_CATEGORIES = ["serious_collision", "impairment_concern", "licence_suspension_or_confiscation",
  "failed_required_test", "dangerous_driving_complaint", "medical_incident_while_driving", "fraudulent_licence",
  "identity_mismatch", "self_reported_unfit", "other"];
export const RELATIONSHIP_TYPES = ["EMPLOYEE", "CONTRACTOR_REVIEWED", "OWNER_DRIVER", "EXTERNAL_DRIVER",
  "AGENCY_DRIVER", "RELATIONSHIP_REVIEW_REQUIRED"];
export const DL_CODES = ["A", "A1", "B", "B1", "B2", "C", "D", "BE", "CE"];

export function humanize(code) {
  if (!code) return "";
  const text = String(code).toLowerCase().replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function pesosFromCentavos(centavos) {
  if (centavos === null || centavos === undefined) return null;
  const whole = Math.trunc(centavos / 100);
  const cents = Math.abs(centavos % 100).toString().padStart(2, "0");
  return `₱${whole.toLocaleString("en-PH")}.${cents}`;
}

export function centavosFromPesosInput(value) {
  // Parse "1,500.50" into 150050 without floating-point arithmetic.
  const clean = String(value ?? "").replace(/[,₱\s]/g, "");
  if (!/^\d+(\.\d{0,2})?$/.test(clean)) return null;
  const [whole, frac = ""] = clean.split(".");
  return Number(whole) * 100 + Number((frac + "00").slice(0, 2));
}

export function detailMessage(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  return detail?.message || fallback;
}
